<div class="selector-container">
<div class="dropdown-trigger" (click)="toggleDropdown()">
    
    <div class="chips-area">
      
      <span class="placeholder" *ngIf="selectedUsers.length === 0">
        Select names...
      </span>

      <div class="chip" *ngFor="let user of selectedUsers">
        <span>{{ user.name }}</span>
        <span class="chip-close" (click)="removeUser(user, $event)">×</span>
      </div>

    </div>

    <span class="arrow" [class.open]="isOpen">▼</span>
  </div>

  <div class="dropdown-menu" *ngIf="isOpen">
    <input 
      type="text" 
      class="search-input" 
      placeholder="Search names..." 
      [(ngModel)]="searchTerm" 
    />

    <div class="dropdown-options">
      <div 
        class="option" 
        *ngFor="let user of filteredUsers" 
        (click)="toggleUser(user)">
        <input type="checkbox" [checked]="isSelected(user)" readonly style="pointer-events: none;" />
        <span>{{ user.name }}</span>
      </div>
      
      <div class="no-results" *ngIf="filteredUsers.length === 0">
        No names found
      </div>
    </div>
  </div>
</div>